import { debounce } from 'lodash';
import { classes, DOM, breakpoints, matchMedia, isiE } from '../const';

const { md, sm } = breakpoints;

const { $window } = DOM;
const { withBg, isVisible, applyFixed, isNavBlack, isBlack, isLowBurger } = classes;

const $menu = $('.js-site-menu');
const $heroNav = $('.js-section-nav').first();
const $mdNav = $('.js-md-nav');
const $headerNav = $('.js-header-nav');
const $headerBg = $('.js-header-bg-overlay');
const $headerLogo = $('.header__logo ');
let $$sections = null;

if (isiE) $$sections = $('.js-section');

let mdNavBgVidible = false;

const checkHeroNav = () => {
  const scrollTop = $window.scrollTop();
  const winHeight = $window.height();
  const logoStart = $headerLogo.offset().top;
  const logoEnd = logoStart + $headerLogo.height();

  if (scrollTop > 150) {
    $headerNav.parent().addClass(applyFixed);
  }
  else {
    $headerNav.parent().removeClass(applyFixed);
  }

  if (scrollTop > logoStart) {
    if (scrollTop < 0.5 * winHeight) {
      const opacity = 0.5 + ((scrollTop - logoStart) / (0.5 * winHeight - logoStart)) * 0.25
      $headerBg.css('opacity', opacity);
    } else {
      $headerBg.css('opacity', 0.75);
    }
  } else {
    $headerBg.css('opacity', 0.5);

  }
  if (matchMedia(sm)) {
    if (scrollTop > logoEnd && !mdNavBgVidible) {
      mdNavBgVidible = true;
      $mdNav.addClass(withBg);
      $menu.addClass(isLowBurger);
    } else if (scrollTop < logoEnd && mdNavBgVidible) {
      mdNavBgVidible = false;
      $mdNav.removeClass(withBg);
      $menu.removeClass(isLowBurger);
    }
  }

  if (matchMedia(md)) {
    if (scrollTop > logoEnd) {
      $heroNav.addClass(isVisible);

    } else if (scrollTop < logoEnd) {
      $heroNav.removeClass(isVisible);
    }

    if (isiE) {
      let $currentSection = null;
      $$sections.each((i, el) => {
        if ($(el).offset().top < scrollTop) {
          $currentSection = $(el);
        }
      });

      if ($currentSection && $currentSection.hasClass(isNavBlack)) {
        $heroNav
          .hide()
          .addClass(isBlack)
          .show();
      } else {
        $heroNav
          .hide()
          .removeClass(isBlack)
          .show();
      }

    }
  }

};

const sectionNav = () => {
  checkHeroNav();
  $window.scroll(checkHeroNav);
  $window.resize(debounce(checkHeroNav, 100));
};

export default sectionNav;
